import { useQuery } from '@tanstack/react-query'
import { OpalApiRequestParams, OpalApiResponseDocument } from '@opallabs/api'
import { customFields } from '@opallabs/api/v3'
import { useWorkspace } from '@opallabs/hooks'
import { globalQueryKeys } from '../../queryKeys'

type ReadCustomFieldsResponse = OpalApiResponseDocument<
  'ReadCustomFieldsV3',
  200
>

type UseReadCustomFieldsParams = {
  params: OpalApiRequestParams<'ReadCustomFieldsV3'>
}

type UseReadCustomFieldsOptions<T = ReadCustomFieldsResponse> =
  UseReadCustomFieldsParams & {
    select?: (data: ReadCustomFieldsResponse) => T
    enabled?: boolean
  }

export const useReadCustomFields = <T = ReadCustomFieldsResponse>({
  params,
  select,
  enabled,
}: UseReadCustomFieldsOptions<T>) => {
  const { uuid: workspaceUuid } = useWorkspace()
  return useQuery({
    queryKey: globalQueryKeys.customFields(workspaceUuid, params),
    queryFn: () =>
      customFields.readCollection({
        params,
      }),
    select,
    enabled,
  })
}
